@switch ((fieldData() ?? control().fieldData).type) {
    @case (FIELD_TYPES.Text) {
        <cipo-text [control]="$any(control())" [(fieldData)]="fieldData" />
    }
    @case (FIELD_TYPES.Number) {
        <cipo-number [control]="$any(control())" [(fieldData)]="fieldData" (onblur)="onblur.emit()" />
    }
    @case (FIELD_TYPES.Select) {
        <cipo-select [control]="$any(control())" [(fieldData)]="fieldData" (onblur)="onblur.emit()" />
    }
    @case (FIELD_TYPES.Checkbox) {
        <cipo-checkbox [control]="$any(control())" [(fieldData)]="fieldData" />
    }
    @case (FIELD_TYPES.DateTime) {
        <cipo-date-time [control]="$any(control())" [(fieldData)]="fieldData" (onblur)="onblur.emit()" />
    }
    @case (FIELD_TYPES.Attachment) {
        <cipo-attachment [control]="$any(control())" [(fieldData)]="fieldData" />
    }
    @case (FIELD_TYPES.Address) {
        <cipo-address [control]="$any(control())" [(fieldData)]="fieldData" />
    }
    @case (FIELD_TYPES.Listbox) {
        <cipo-listbox [control]="$any(control())" [(fieldData)]="fieldData" />
    }
    @case (FIELD_TYPES.RadioGroup) {
        <cipo-radio-group [control]="$any(control())" [(fieldData)]="fieldData" />
    }
    @case (FIELD_TYPES.RichText) {
        <app-froala
            [control]="$any(control())"
            [(fieldData)]="fieldData"
            [tributeOptions]="{ mentions: {} }"
            [froalaoptions]="FroalaConfig.inline" />
    }
    @default {
        <cipo-text [control]="$any(control())" [(fieldData)]="fieldData" />
    }
}
